import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  id: [
    {...makeRule('请输入正确的智能外呼ID', 'integer', 'blur', false), min: 1},
  ],
}

export let formRules = {
  title: [
    {...makeRule('请输入智能外呼名称', 'string')},
  ],
  customer_id: [
    {...makeRule('请选择客户', 'integer')},
  ],
  project_id: [
    {...makeRule('请选择项目', 'integer')},
  ],
  robot_tpl: [
    {...makeRule('请输入外呼模板', 'string')},
  ],
  retry_times: [
    {...makeRule('请输入未拨打重试次数', 'string')},
  ],
  retry_duration: [
    {...makeRule('请输入未拨打重试间隔', 'string')},
  ],
  file: [
    {...makeRule('请导入客户信息', 'object')},
  ],
}

export let editCustomerFormRules = {
  title: [
    {...makeRule('请输入智能外呼名称', 'string')},
  ],
  customer_id: [
    {...makeRule('请选择客户', 'integer')},
  ],
  project_id: [
    {...makeRule('请选择项目', 'integer')},
  ],
  robot_tpl: [
    {...makeRule('请输入外呼模板', 'string')},
  ],
  retry_times: [
    {...makeRule('请输入未拨打重试次数', 'string')},
  ],
  retry_duration: [
    {...makeRule('请输入未拨打重试间隔', 'string')},
  ],
  file: [
    {...makeRule('请导入客户信息', 'object')},
  ],
}



// WEBPACK FOOTER //
// ./src/views/intelligent-outbound-call/intelligent-outbound-call.rules.js